import { blinkConstants } from '@thoughtspot/blink-constants';
import { useTranslation } from '@thoughtspot/i18n';
import { Accordion } from '@thoughtspot/radiant-react/widgets/accordion';
import { Alert, BannerAlertType, } from '@thoughtspot/radiant-react/widgets/alert';
import { Button } from '@thoughtspot/radiant-react/widgets/button/button';
import { IconID } from '@thoughtspot/radiant-react/widgets/icon/icon-constants';
import { Horizontal, Vertical, } from '@thoughtspot/radiant-react/widgets/layout';
import { LoadingIndicator } from '@thoughtspot/radiant-react/widgets/loading-indicator';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import { isIamV2OidcEnabled, isOrgUiEnabled, } from '@thoughtspot/session-service';
import { getClientId, isOktaEnabled, isSamlEnabled, } from '@thoughtspot/system-config-service';
import React, { useEffect, useRef, useState } from 'react';
import { AddIdentityProvider } from '../add-Identity-Provider/add-identity-provider';
import { AttributeMapping } from '../attribute-mapping/attribute-mapping.container';
import { defaultFormValues, getSubDomainIfOrgEnabled, IDP_TYPE, TranslationsKeys, } from '../constant';
import { IamV2MigrationAutomationBanner } from '../iamv2-migration/iamv2-migration.container';
import { IdentityDetails } from '../identity-details/identity-details.container';
import { GENERIC, OIDC } from '../oidc-identity-details/oidc-form-config';
import { OidcIdentityDetails } from '../oidc-identity-details/oidc-identity-details.container';
import { ProvierList } from '../provider-list/provider-list.container';
import { StepsIndicator } from '../steps-indicator/steps-indicator';
import { AddThoughtSpotToIDP } from '../thoughtspot-to-idp/add-thoughtspot-to-idp.container';
import styles from './saml-config.module.scss';
export const SamlConfig = ({ isIdentityProviderDetails = false, setIsIdentityProviderDetails, showIAMV2MigrationBannerWhenEnabled, currentOrgInfo, }) => {
    const [showAddSamlButton, setShowAddSamlButton] = useState(true);
    const isOIDCEnabled = isIamV2OidcEnabled();
    const isMigrationBannerVisible = isOktaEnabled() && isSamlEnabled();
    const { t } = useTranslation();
    const getTranslations = (key, args) => t(`${key}`, args);
    const [addProvider, setaAddProvider] = useState(false);
    const [IdentityProviderDetails, setIdentityProviderDetails] = useState(false);
    const [shouldDisplayLoaderText, setShouldDisplayLoaderText] = useState(false);
    const [addThoughtSpotToIDP, setAddThoughtSpotToIDP] = useState(false);
    const [provierList, setProviderList] = useState(true);
    const [editData, setEditData] = useState(null);
    const [edit, setEdit] = useState(false);
    const [samlResponse, setSamlResponse] = useState(null);
    const [attributeMapping, setAttributeMapping] = useState(false);
    const [errorBanner, setErrorBanner] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [idpType, setIdpType] = useState(IDP_TYPE.SAML);
    const [screenLoader, setScreenLoader] = useState(false);
    const formDataRef = useRef();
    const attributeValues = useRef({});
    const clientId = getClientId();
    const [idpNamesList, setIdpNamesList] = useState([]);
    const setDefaultFormValues = () => {
        formDataRef.current = { ...defaultFormValues };
        formDataRef.current.certData = { x5c: '' };
        formDataRef.current.sso = {
            url: '',
            binding: 'POST',
        };
    };
    const onAddProviderClick = (selectedIdp) => {
        setDefaultFormValues();
        setIdpType(selectedIdp);
        setIdentityProviderDetails(true);
        setaAddProvider(false);
    };
    const remount = () => {
        setProviderList(false);
        setTimeout(() => {
            setProviderList(true);
        }, 1000);
    };
    const hideBanner = () => {
        setErrorBanner(false);
    };
    const onProviderForm = (isProviderList, isAddThoughtSpotToIDP, isAttbuteMap, samlResponse) => {
        if (isProviderList !== provierList) {
            setProviderList(isProviderList);
            setIsIdentityProviderDetails(!isProviderList);
        }
        if (isAddThoughtSpotToIDP !== addThoughtSpotToIDP) {
            if (samlResponse)
                setSamlResponse(samlResponse);
            setAddThoughtSpotToIDP(isAddThoughtSpotToIDP);
            if (edit) {
                setEditData(null);
                setEdit(false);
            }
        }
        if (isAttbuteMap !== attributeMapping) {
            setAttributeMapping(isAttbuteMap);
        }
        if (IdentityProviderDetails) {
            setIdentityProviderDetails(false);
        }
        if (errorBanner)
            hideBanner();
    };
    const backToIdentityDetails = () => {
        setAttributeMapping(false);
        setIdentityProviderDetails(true);
    };
    const listIsEmpty = () => {
        setProviderList(false);
        setIsIdentityProviderDetails(false);
        setaAddProvider(true);
        setShowAddSamlButton(false);
    };
    const editConnection = (item) => {
        setShowAddSamlButton(false);
        setEditData(item);
        setEdit(true);
    };
    const showHideBanner = (message, status) => {
        setErrorMessage(message);
        setErrorBanner(status);
        if (status)
            setIsIdentityProviderDetails(false);
    };
    const resetEdit = () => {
        setEdit(false);
        setIsIdentityProviderDetails(false);
    };
    useEffect(() => {
        if (edit) {
            setIdpType(editData.type);
            setIdentityProviderDetails(true);
            setProviderList(false);
        }
    }, [edit]);
    useEffect(() => {
        if (isIdentityProviderDetails) {
            setDefaultFormValues();
            setIdentityProviderDetails(true);
            setProviderList(false);
            setShowAddSamlButton(false);
        }
    }, [isIdentityProviderDetails]);
    useEffect(() => {
        if (provierList) {
            setDefaultFormValues();
            setShowAddSamlButton(true);
        }
    }, [provierList]);
    const setAttributeValues = (data) => {
        attributeValues.current = data;
    };
    const shouldShowAddSamlButton = () => {
        return (isOIDCEnabled ||
            (isOktaEnabled() &&
                isOrgUiEnabled() &&
                !getSubDomainIfOrgEnabled() &&
                currentOrgInfo?.orgId ===
                    blinkConstants.orgs.MASTER_ID.toString()));
    };
    const isIdpWithNameExits = (idpName, id) => {
        return (idpNamesList.filter(idp => idp.connectionName === idpName && idp.id !== id).length !== 0);
    };
    return (React.createElement(LoadingIndicator.Global, { hideLoader: !screenLoader, loadingText: shouldDisplayLoaderText && screenLoader
            ? t(TranslationsKeys.SAVE_CONFIRMATION_LOADING_MESSAGE)
            : undefined, className: `${styles.loadIndicator} ${screenLoader ? styles.disallowScroll : ''}` },
        React.createElement(Accordion, null,
            React.createElement(React.Fragment, null,
                React.createElement(Vertical, { className: styles.samlHeader },
                    React.createElement(Horizontal, { className: styles.titleWrapper },
                        (provierList ||
                            (addProvider && !isOIDCEnabled)) && (React.createElement(Typography, { variant: "h2", noMargin: true }, getTranslations(isOIDCEnabled
                            ? TranslationsKeys.OIDC_LIST_HEADER
                            : TranslationsKeys.SAML_LIST_HEADER))),
                        showAddSamlButton && shouldShowAddSamlButton() && (React.createElement(Button, { icon: IconID.PLUS, "data-testid": "addIdpButton", text: getTranslations(isOIDCEnabled
                                ? TranslationsKeys.ADD_IDP_BUTTON
                                : TranslationsKeys.ADD_IDP_BUTTON_SAML), onClick: (event) => {
                                if (isOIDCEnabled) {
                                    setaAddProvider(true);
                                    setProviderList(false);
                                }
                                else {
                                    setProviderList(false);
                                    onAddProviderClick(IDP_TYPE.SAML);
                                }
                                setShowAddSamlButton(false);
                            }, type: "primary" })),
                        addProvider && isOIDCEnabled && (React.createElement(Button, { icon: IconID.ARROW_LEFT, text: "Back", onClick: (event) => {
                                setaAddProvider(false);
                                setProviderList(true);
                            }, type: "primary" })))),
                React.createElement(Vertical, { className: styles.samlContainer },
                    isMigrationBannerVisible && (React.createElement(IamV2MigrationAutomationBanner, { setScreenLoader: setScreenLoader, setShouldDisplayLoaderText: setShouldDisplayLoaderText })),
                    errorBanner && !isMigrationBannerVisible && (React.createElement(Alert.Banner, { message: errorMessage, isVisible: true, type: BannerAlertType.ERROR, onClose: hideBanner })),
                    (IdentityProviderDetails ||
                        attributeMapping ||
                        addThoughtSpotToIDP ||
                        (addProvider && isOIDCEnabled)) && (React.createElement(StepsIndicator, { isFirst: addProvider, isSecond: IdentityProviderDetails, isThird: attributeMapping, isFourth: addThoughtSpotToIDP })),
                    addProvider && (React.createElement(AddIdentityProvider, { onAddProviderClick: onAddProviderClick })),
                    addThoughtSpotToIDP && (React.createElement(AddThoughtSpotToIDP, { onProviderForm: onProviderForm, setScreenLoader: setScreenLoader, clientId: clientId, formDataRef: formDataRef })),
                    IdentityProviderDetails &&
                        (idpType !== IDP_TYPE.SAML ? (React.createElement(OidcIdentityDetails, { onProviderForm: onProviderForm, setScreenLoader: setScreenLoader, editData: editData, idpType: idpType, showHideBanner: showHideBanner, edit: edit, clientId: clientId, formDataRef: formDataRef, resetEdit: resetEdit, attributeValues: attributeValues, setAttributeValues: setAttributeValues, currentOrgInfo: currentOrgInfo, formFields: idpType === IDP_TYPE.OIDC
                                ? GENERIC.fields
                                : OIDC.fields })) : (React.createElement(IdentityDetails, { onProviderForm: onProviderForm, setScreenLoader: setScreenLoader, editData: editData, edit: edit, clientId: clientId, formDataRef: formDataRef, resetEdit: resetEdit, attributeValues: attributeValues, setAttributeValues: setAttributeValues, showHideBanner: showHideBanner, currentOrgInfo: currentOrgInfo, idpWithNameExists: isIdpWithNameExits }))),
                    provierList && (React.createElement(ProvierList, { setScreenloader: setScreenLoader, listIsEmpty: listIsEmpty, editConnection: editConnection, remount: remount, clientId: clientId, formDataRef: formDataRef, showHideBanner: showHideBanner, showIAMV2MigrationBannerWhenEnabled: showIAMV2MigrationBannerWhenEnabled, currentOrgInfo: currentOrgInfo, setIdpNamesList: setIdpNamesList })),
                    attributeMapping && (React.createElement(AttributeMapping, { onProviderForm: onProviderForm, setScreenLoader: setScreenLoader, clientId: clientId, backToIdentityDetails: backToIdentityDetails, formDataRef: formDataRef, edit: edit, showHideBanner: showHideBanner, resetEdit: resetEdit, attributeValues: attributeValues, currentOrgInfo: currentOrgInfo })))))));
};
//# sourceMappingURL=saml-config.js.map